module.exports = "https://static.wanderu.com/static/media/phone-with-qr3x.179e2504.png";